import React, { useEffect } from "react";
import { Alert, Col, Container, Row } from "reactstrap";

import Header from "./Header";
import MainDetails from "./MainDetails";
import AdditionalDetails from "./AdditionalDetails";
import { useParams, useLocation } from "react-router-dom";
import { usePageActivity } from "Components/Hooks/UsePageActivity";
import { useSelector, useDispatch } from "react-redux";
import { createSelector } from "reselect";
import { getUKSanctionedItem as onGeUKSanctionedItem } from "../../../../slices/thunks";
import BreadCrumb from "Components/Common/BreadCrumb";

const ViewUKSanctionedItem = () => {
  const location = useLocation();
  const dispatch: any = useDispatch();

  const { id: itemId } = useParams();
  usePageActivity(location.pathname, "View UK Sanctions List", itemId);

  useEffect(() => {
    dispatch(onGeUKSanctionedItem(itemId));
  }, [itemId, dispatch]);

  const selectLayoutState = (state: any) => state.SanctionsList;
  const selectProperties = createSelector(selectLayoutState, (state) => ({
    ukSanctionedItem: state.ukSanctionedItem,
  }));

  const { ukSanctionedItem } = useSelector(selectProperties);

  document.title = "UK Sanctioned Item | CIMS";

  return (
    <React.Fragment>
      <div className="page-content">
        <Container fluid>
          <BreadCrumb
            title="UK Sanction Details"
            pageTitles={[
              {
                title: "Dashboard",
                link: "/",
              },
              { title: "UK Sanctions List", link: "/sanctions-list/uk" },
            ]}
            back
          />
          <Row>
            <Col>
              <Alert color="danger" className="material-shadow">
                <strong> UK Sanction! </strong> This entity has been sanctioned
                by the UK. Please check the profile below for more information.
              </Alert>
            </Col>
          </Row>
          <Row>
            <Header data={ukSanctionedItem} />
          </Row>
          <Row>
            <MainDetails data={ukSanctionedItem} />
            <AdditionalDetails data={ukSanctionedItem} />
          </Row>
        </Container>
      </div>
    </React.Fragment>
  );
};

export default ViewUKSanctionedItem;
